module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Forward-fd9da1ab354b772c60fc5ab9d1aa956a.svg";